// source: pbtypes/cloud/services/skyfront/cloud_overrides.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skyfront.DeviceCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.LocationStreamCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.ParaverseScenarioMarkerCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.RtkCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.RtkCredentials', null, global);
goog.exportSymbol('proto.skyfront.SampleCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.SimOrchestratorCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.SiteCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.SiteSecurityCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.SkyfrontCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.VideoCaptureCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.WacsCloudOverrides', null, global);
goog.exportSymbol('proto.skyfront.WacsReleaseVersion', null, global);
goog.exportSymbol('proto.skyfront.WeatherInferenceCloudOverrides', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.WacsCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skyfront.WacsCloudOverrides.repeatedFields_, null);
};
goog.inherits(proto.skyfront.WacsCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.WacsCloudOverrides.displayName = 'proto.skyfront.WacsCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.SampleCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.SampleCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.SampleCloudOverrides.displayName = 'proto.skyfront.SampleCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.SiteSecurityCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.SiteSecurityCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.SiteSecurityCloudOverrides.displayName = 'proto.skyfront.SiteSecurityCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.LocationStreamCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.LocationStreamCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.LocationStreamCloudOverrides.displayName = 'proto.skyfront.LocationStreamCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.ParaverseScenarioMarkerCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.ParaverseScenarioMarkerCloudOverrides.displayName = 'proto.skyfront.ParaverseScenarioMarkerCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.SimOrchestratorCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.SimOrchestratorCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.SimOrchestratorCloudOverrides.displayName = 'proto.skyfront.SimOrchestratorCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.VideoCaptureCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.VideoCaptureCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.VideoCaptureCloudOverrides.displayName = 'proto.skyfront.VideoCaptureCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.WeatherInferenceCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.WeatherInferenceCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.WeatherInferenceCloudOverrides.displayName = 'proto.skyfront.WeatherInferenceCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.SiteCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.SiteCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.SiteCloudOverrides.displayName = 'proto.skyfront.SiteCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.RtkCredentials = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.RtkCredentials, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.RtkCredentials.displayName = 'proto.skyfront.RtkCredentials';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.RtkCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.RtkCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.RtkCloudOverrides.displayName = 'proto.skyfront.RtkCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.DeviceCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.DeviceCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.DeviceCloudOverrides.displayName = 'proto.skyfront.DeviceCloudOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skyfront.SkyfrontCloudOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skyfront.SkyfrontCloudOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skyfront.SkyfrontCloudOverrides.displayName = 'proto.skyfront.SkyfrontCloudOverrides';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skyfront.WacsCloudOverrides.repeatedFields_ = [2,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.WacsCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.WacsCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.WacsCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.WacsCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
excludedChannelsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
obssHighThreshCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
dfsStickyPenalty: jspb.Message.getFieldWithDefault(msg, 4, 0),
releaseVersion: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
validUnii3PrimaryChannelsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.WacsCloudOverrides}
 */
proto.skyfront.WacsCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.WacsCloudOverrides;
  return proto.skyfront.WacsCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.WacsCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.WacsCloudOverrides}
 */
proto.skyfront.WacsCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      reader.readPackableInt32Into(msg.getExcludedChannelsList());
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setObssHighThreshCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDfsStickyPenalty(value);
      break;
    case 5:
      var value = /** @type {!proto.skyfront.WacsReleaseVersion} */ (reader.readEnum());
      msg.setReleaseVersion(value);
      break;
    case 6:
      reader.readPackableInt32Into(msg.getValidUnii3PrimaryChannelsList());
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.WacsCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.WacsCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.WacsCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.WacsCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getExcludedChannelsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getObssHighThreshCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDfsStickyPenalty();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {!proto.skyfront.WacsReleaseVersion} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getValidUnii3PrimaryChannelsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      6,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.WacsCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated int32 excluded_channels = 2;
 * @return {!Array<number>}
 */
proto.skyfront.WacsCloudOverrides.prototype.getExcludedChannelsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.setExcludedChannelsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.addExcludedChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.clearExcludedChannelsList = function() {
  return this.setExcludedChannelsList([]);
};


/**
 * optional int32 obss_high_thresh_count = 3;
 * @return {number}
 */
proto.skyfront.WacsCloudOverrides.prototype.getObssHighThreshCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.setObssHighThreshCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 dfs_sticky_penalty = 4;
 * @return {number}
 */
proto.skyfront.WacsCloudOverrides.prototype.getDfsStickyPenalty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.setDfsStickyPenalty = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional WacsReleaseVersion release_version = 5;
 * @return {!proto.skyfront.WacsReleaseVersion}
 */
proto.skyfront.WacsCloudOverrides.prototype.getReleaseVersion = function() {
  return /** @type {!proto.skyfront.WacsReleaseVersion} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.skyfront.WacsReleaseVersion} value
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.setReleaseVersion = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.clearReleaseVersion = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WacsCloudOverrides.prototype.hasReleaseVersion = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated int32 valid_unii3_primary_channels = 6;
 * @return {!Array<number>}
 */
proto.skyfront.WacsCloudOverrides.prototype.getValidUnii3PrimaryChannelsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.setValidUnii3PrimaryChannelsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.addValidUnii3PrimaryChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skyfront.WacsCloudOverrides} returns this
 */
proto.skyfront.WacsCloudOverrides.prototype.clearValidUnii3PrimaryChannelsList = function() {
  return this.setValidUnii3PrimaryChannelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.SampleCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.SampleCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.SampleCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SampleCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.SampleCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.SampleCloudOverrides;
  return proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.SampleCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.SampleCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.SampleCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.SampleCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.SampleCloudOverrides} returns this
 */
proto.skyfront.SampleCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.SiteSecurityCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.SiteSecurityCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SiteSecurityCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
debugLogging: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
autoZoomLevel: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.SiteSecurityCloudOverrides}
 */
proto.skyfront.SiteSecurityCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.SiteSecurityCloudOverrides;
  return proto.skyfront.SiteSecurityCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.SiteSecurityCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.SiteSecurityCloudOverrides}
 */
proto.skyfront.SiteSecurityCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebugLogging(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAutoZoomLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.SiteSecurityCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.SiteSecurityCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SiteSecurityCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.SiteSecurityCloudOverrides} returns this
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool debug_logging = 2;
 * @return {boolean}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.getDebugLogging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.SiteSecurityCloudOverrides} returns this
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.setDebugLogging = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.SiteSecurityCloudOverrides} returns this
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.clearDebugLogging = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.hasDebugLogging = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float auto_zoom_level = 3;
 * @return {number}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.getAutoZoomLevel = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.SiteSecurityCloudOverrides} returns this
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.setAutoZoomLevel = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.SiteSecurityCloudOverrides} returns this
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.clearAutoZoomLevel = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteSecurityCloudOverrides.prototype.hasAutoZoomLevel = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.LocationStreamCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.LocationStreamCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.LocationStreamCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.LocationStreamCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.LocationStreamCloudOverrides}
 */
proto.skyfront.LocationStreamCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.LocationStreamCloudOverrides;
  return proto.skyfront.LocationStreamCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.LocationStreamCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.LocationStreamCloudOverrides}
 */
proto.skyfront.LocationStreamCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.LocationStreamCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.LocationStreamCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.LocationStreamCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.LocationStreamCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.LocationStreamCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.LocationStreamCloudOverrides} returns this
 */
proto.skyfront.LocationStreamCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.ParaverseScenarioMarkerCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.ParaverseScenarioMarkerCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.ParaverseScenarioMarkerCloudOverrides}
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.ParaverseScenarioMarkerCloudOverrides;
  return proto.skyfront.ParaverseScenarioMarkerCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.ParaverseScenarioMarkerCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.ParaverseScenarioMarkerCloudOverrides}
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.ParaverseScenarioMarkerCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.ParaverseScenarioMarkerCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.ParaverseScenarioMarkerCloudOverrides} returns this
 */
proto.skyfront.ParaverseScenarioMarkerCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.SimOrchestratorCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.SimOrchestratorCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.SimOrchestratorCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SimOrchestratorCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.SimOrchestratorCloudOverrides}
 */
proto.skyfront.SimOrchestratorCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.SimOrchestratorCloudOverrides;
  return proto.skyfront.SimOrchestratorCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.SimOrchestratorCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.SimOrchestratorCloudOverrides}
 */
proto.skyfront.SimOrchestratorCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.SimOrchestratorCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.SimOrchestratorCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.SimOrchestratorCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SimOrchestratorCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.SimOrchestratorCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.SimOrchestratorCloudOverrides} returns this
 */
proto.skyfront.SimOrchestratorCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.VideoCaptureCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.VideoCaptureCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.VideoCaptureCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
videoBufferSeconds: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
thumbnailCaptureDelay: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.VideoCaptureCloudOverrides}
 */
proto.skyfront.VideoCaptureCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.VideoCaptureCloudOverrides;
  return proto.skyfront.VideoCaptureCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.VideoCaptureCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.VideoCaptureCloudOverrides}
 */
proto.skyfront.VideoCaptureCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVideoBufferSeconds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setThumbnailCaptureDelay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.VideoCaptureCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.VideoCaptureCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.VideoCaptureCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.VideoCaptureCloudOverrides} returns this
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 video_buffer_seconds = 2;
 * @return {number}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.getVideoBufferSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.VideoCaptureCloudOverrides} returns this
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.setVideoBufferSeconds = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.VideoCaptureCloudOverrides} returns this
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.clearVideoBufferSeconds = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.hasVideoBufferSeconds = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float thumbnail_capture_delay = 3;
 * @return {number}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.getThumbnailCaptureDelay = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.VideoCaptureCloudOverrides} returns this
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.setThumbnailCaptureDelay = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.VideoCaptureCloudOverrides} returns this
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.clearThumbnailCaptureDelay = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.VideoCaptureCloudOverrides.prototype.hasThumbnailCaptureDelay = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.WeatherInferenceCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.WeatherInferenceCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.WeatherInferenceCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
inferenceIntervalSeconds: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
enableTrainingDataCapture: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
enableDebugLogging: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
lateralCloudClearance: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
lateralVisibility: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
verticalCloudClearance: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides}
 */
proto.skyfront.WeatherInferenceCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.WeatherInferenceCloudOverrides;
  return proto.skyfront.WeatherInferenceCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.WeatherInferenceCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides}
 */
proto.skyfront.WeatherInferenceCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInferenceIntervalSeconds(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTrainingDataCapture(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDebugLogging(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLateralCloudClearance(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLateralVisibility(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVerticalCloudClearance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.WeatherInferenceCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.WeatherInferenceCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.WeatherInferenceCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 inference_interval_seconds = 2;
 * @return {number}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getInferenceIntervalSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setInferenceIntervalSeconds = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.clearInferenceIntervalSeconds = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.hasInferenceIntervalSeconds = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool enable_training_data_capture = 3;
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getEnableTrainingDataCapture = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setEnableTrainingDataCapture = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.clearEnableTrainingDataCapture = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.hasEnableTrainingDataCapture = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool enable_debug_logging = 4;
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getEnableDebugLogging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setEnableDebugLogging = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.clearEnableDebugLogging = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.hasEnableDebugLogging = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 lateral_cloud_clearance = 5;
 * @return {number}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getLateralCloudClearance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setLateralCloudClearance = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.clearLateralCloudClearance = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.hasLateralCloudClearance = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float lateral_visibility = 6;
 * @return {number}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getLateralVisibility = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setLateralVisibility = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.clearLateralVisibility = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.hasLateralVisibility = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 vertical_cloud_clearance = 7;
 * @return {number}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.getVerticalCloudClearance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.setVerticalCloudClearance = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.WeatherInferenceCloudOverrides} returns this
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.clearVerticalCloudClearance = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.WeatherInferenceCloudOverrides.prototype.hasVerticalCloudClearance = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.SiteCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.SiteCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.SiteCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SiteCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
wacsCloudOverrides: (f = msg.getWacsCloudOverrides()) && proto.skyfront.WacsCloudOverrides.toObject(includeInstance, f),
sampleCloudOverrides: (f = msg.getSampleCloudOverrides()) && proto.skyfront.SampleCloudOverrides.toObject(includeInstance, f),
sampleGoCloudOverrides: (f = msg.getSampleGoCloudOverrides()) && proto.skyfront.SampleCloudOverrides.toObject(includeInstance, f),
siteSecurityCloudOverrides: (f = msg.getSiteSecurityCloudOverrides()) && proto.skyfront.SiteSecurityCloudOverrides.toObject(includeInstance, f),
simOrchestratorCloudOverrides: (f = msg.getSimOrchestratorCloudOverrides()) && proto.skyfront.SimOrchestratorCloudOverrides.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.SiteCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.SiteCloudOverrides;
  return proto.skyfront.SiteCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.SiteCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.SiteCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skyfront.WacsCloudOverrides;
      reader.readMessage(value,proto.skyfront.WacsCloudOverrides.deserializeBinaryFromReader);
      msg.setWacsCloudOverrides(value);
      break;
    case 2:
      var value = new proto.skyfront.SampleCloudOverrides;
      reader.readMessage(value,proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleCloudOverrides(value);
      break;
    case 3:
      var value = new proto.skyfront.SampleCloudOverrides;
      reader.readMessage(value,proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleGoCloudOverrides(value);
      break;
    case 4:
      var value = new proto.skyfront.SiteSecurityCloudOverrides;
      reader.readMessage(value,proto.skyfront.SiteSecurityCloudOverrides.deserializeBinaryFromReader);
      msg.setSiteSecurityCloudOverrides(value);
      break;
    case 5:
      var value = new proto.skyfront.SimOrchestratorCloudOverrides;
      reader.readMessage(value,proto.skyfront.SimOrchestratorCloudOverrides.deserializeBinaryFromReader);
      msg.setSimOrchestratorCloudOverrides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.SiteCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.SiteCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.SiteCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SiteCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWacsCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skyfront.WacsCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSampleCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSampleGoCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSiteSecurityCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.skyfront.SiteSecurityCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSimOrchestratorCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.skyfront.SimOrchestratorCloudOverrides.serializeBinaryToWriter
    );
  }
};


/**
 * optional WacsCloudOverrides wacs_cloud_overrides = 1;
 * @return {?proto.skyfront.WacsCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.prototype.getWacsCloudOverrides = function() {
  return /** @type{?proto.skyfront.WacsCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.WacsCloudOverrides, 1));
};


/**
 * @param {?proto.skyfront.WacsCloudOverrides|undefined} value
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
*/
proto.skyfront.SiteCloudOverrides.prototype.setWacsCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
 */
proto.skyfront.SiteCloudOverrides.prototype.clearWacsCloudOverrides = function() {
  return this.setWacsCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteCloudOverrides.prototype.hasWacsCloudOverrides = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SampleCloudOverrides sample_cloud_overrides = 2;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.prototype.getSampleCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SampleCloudOverrides, 2));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
*/
proto.skyfront.SiteCloudOverrides.prototype.setSampleCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
 */
proto.skyfront.SiteCloudOverrides.prototype.clearSampleCloudOverrides = function() {
  return this.setSampleCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteCloudOverrides.prototype.hasSampleCloudOverrides = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SampleCloudOverrides sample_go_cloud_overrides = 3;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.prototype.getSampleGoCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SampleCloudOverrides, 3));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
*/
proto.skyfront.SiteCloudOverrides.prototype.setSampleGoCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
 */
proto.skyfront.SiteCloudOverrides.prototype.clearSampleGoCloudOverrides = function() {
  return this.setSampleGoCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteCloudOverrides.prototype.hasSampleGoCloudOverrides = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SiteSecurityCloudOverrides site_security_cloud_overrides = 4;
 * @return {?proto.skyfront.SiteSecurityCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.prototype.getSiteSecurityCloudOverrides = function() {
  return /** @type{?proto.skyfront.SiteSecurityCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SiteSecurityCloudOverrides, 4));
};


/**
 * @param {?proto.skyfront.SiteSecurityCloudOverrides|undefined} value
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
*/
proto.skyfront.SiteCloudOverrides.prototype.setSiteSecurityCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
 */
proto.skyfront.SiteCloudOverrides.prototype.clearSiteSecurityCloudOverrides = function() {
  return this.setSiteSecurityCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteCloudOverrides.prototype.hasSiteSecurityCloudOverrides = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SimOrchestratorCloudOverrides sim_orchestrator_cloud_overrides = 5;
 * @return {?proto.skyfront.SimOrchestratorCloudOverrides}
 */
proto.skyfront.SiteCloudOverrides.prototype.getSimOrchestratorCloudOverrides = function() {
  return /** @type{?proto.skyfront.SimOrchestratorCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SimOrchestratorCloudOverrides, 5));
};


/**
 * @param {?proto.skyfront.SimOrchestratorCloudOverrides|undefined} value
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
*/
proto.skyfront.SiteCloudOverrides.prototype.setSimOrchestratorCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SiteCloudOverrides} returns this
 */
proto.skyfront.SiteCloudOverrides.prototype.clearSimOrchestratorCloudOverrides = function() {
  return this.setSimOrchestratorCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SiteCloudOverrides.prototype.hasSimOrchestratorCloudOverrides = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.RtkCredentials.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.RtkCredentials.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.RtkCredentials} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.RtkCredentials.toObject = function(includeInstance, msg) {
  var f, obj = {
host: jspb.Message.getFieldWithDefault(msg, 1, ""),
port: jspb.Message.getFieldWithDefault(msg, 2, 0),
username: jspb.Message.getFieldWithDefault(msg, 3, ""),
password: jspb.Message.getFieldWithDefault(msg, 4, ""),
mountpoint: jspb.Message.getFieldWithDefault(msg, 5, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.RtkCredentials}
 */
proto.skyfront.RtkCredentials.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.RtkCredentials;
  return proto.skyfront.RtkCredentials.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.RtkCredentials} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.RtkCredentials}
 */
proto.skyfront.RtkCredentials.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setHost(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPort(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setUsername(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMountpoint(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.RtkCredentials.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.RtkCredentials.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.RtkCredentials} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.RtkCredentials.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMountpoint();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string host = 1;
 * @return {string}
 */
proto.skyfront.RtkCredentials.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skyfront.RtkCredentials} returns this
 */
proto.skyfront.RtkCredentials.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 port = 2;
 * @return {number}
 */
proto.skyfront.RtkCredentials.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.RtkCredentials} returns this
 */
proto.skyfront.RtkCredentials.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string username = 3;
 * @return {string}
 */
proto.skyfront.RtkCredentials.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.skyfront.RtkCredentials} returns this
 */
proto.skyfront.RtkCredentials.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string password = 4;
 * @return {string}
 */
proto.skyfront.RtkCredentials.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.skyfront.RtkCredentials} returns this
 */
proto.skyfront.RtkCredentials.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string mountpoint = 5;
 * @return {string}
 */
proto.skyfront.RtkCredentials.prototype.getMountpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.skyfront.RtkCredentials} returns this
 */
proto.skyfront.RtkCredentials.prototype.setMountpoint = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool enabled = 6;
 * @return {boolean}
 */
proto.skyfront.RtkCredentials.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.RtkCredentials} returns this
 */
proto.skyfront.RtkCredentials.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.RtkCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.RtkCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.RtkCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.RtkCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
rtkCredentials: (f = msg.getRtkCredentials()) && proto.skyfront.RtkCredentials.toObject(includeInstance, f),
enableCloudNtrip: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
enableOnVehicleNtrip: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
configVersion: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.RtkCloudOverrides}
 */
proto.skyfront.RtkCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.RtkCloudOverrides;
  return proto.skyfront.RtkCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.RtkCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.RtkCloudOverrides}
 */
proto.skyfront.RtkCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skyfront.RtkCredentials;
      reader.readMessage(value,proto.skyfront.RtkCredentials.deserializeBinaryFromReader);
      msg.setRtkCredentials(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCloudNtrip(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOnVehicleNtrip(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConfigVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.RtkCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.RtkCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.RtkCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.RtkCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRtkCredentials();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skyfront.RtkCredentials.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional RtkCredentials rtk_credentials = 1;
 * @return {?proto.skyfront.RtkCredentials}
 */
proto.skyfront.RtkCloudOverrides.prototype.getRtkCredentials = function() {
  return /** @type{?proto.skyfront.RtkCredentials} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.RtkCredentials, 1));
};


/**
 * @param {?proto.skyfront.RtkCredentials|undefined} value
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
*/
proto.skyfront.RtkCloudOverrides.prototype.setRtkCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.clearRtkCredentials = function() {
  return this.setRtkCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.RtkCloudOverrides.prototype.hasRtkCredentials = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool enable_cloud_ntrip = 2;
 * @return {boolean}
 */
proto.skyfront.RtkCloudOverrides.prototype.getEnableCloudNtrip = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.setEnableCloudNtrip = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.clearEnableCloudNtrip = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.RtkCloudOverrides.prototype.hasEnableCloudNtrip = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool enable_on_vehicle_ntrip = 3;
 * @return {boolean}
 */
proto.skyfront.RtkCloudOverrides.prototype.getEnableOnVehicleNtrip = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.setEnableOnVehicleNtrip = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.clearEnableOnVehicleNtrip = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.RtkCloudOverrides.prototype.hasEnableOnVehicleNtrip = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 config_version = 4;
 * @return {number}
 */
proto.skyfront.RtkCloudOverrides.prototype.getConfigVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.setConfigVersion = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skyfront.RtkCloudOverrides} returns this
 */
proto.skyfront.RtkCloudOverrides.prototype.clearConfigVersion = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.RtkCloudOverrides.prototype.hasConfigVersion = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.DeviceCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.DeviceCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.DeviceCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.DeviceCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
sampleCloudOverrides: (f = msg.getSampleCloudOverrides()) && proto.skyfront.SampleCloudOverrides.toObject(includeInstance, f),
locationStreamCloudOverrides: (f = msg.getLocationStreamCloudOverrides()) && proto.skyfront.LocationStreamCloudOverrides.toObject(includeInstance, f),
rtkCloudOverrides: (f = msg.getRtkCloudOverrides()) && proto.skyfront.RtkCloudOverrides.toObject(includeInstance, f),
videoCaptureCloudOverrides: (f = msg.getVideoCaptureCloudOverrides()) && proto.skyfront.VideoCaptureCloudOverrides.toObject(includeInstance, f),
paraverseScenarioMarkerCloudOverrides: (f = msg.getParaverseScenarioMarkerCloudOverrides()) && proto.skyfront.ParaverseScenarioMarkerCloudOverrides.toObject(includeInstance, f),
weatherInferenceCloudOverrides: (f = msg.getWeatherInferenceCloudOverrides()) && proto.skyfront.WeatherInferenceCloudOverrides.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.DeviceCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.DeviceCloudOverrides;
  return proto.skyfront.DeviceCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.DeviceCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.DeviceCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skyfront.SampleCloudOverrides;
      reader.readMessage(value,proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleCloudOverrides(value);
      break;
    case 2:
      var value = new proto.skyfront.LocationStreamCloudOverrides;
      reader.readMessage(value,proto.skyfront.LocationStreamCloudOverrides.deserializeBinaryFromReader);
      msg.setLocationStreamCloudOverrides(value);
      break;
    case 3:
      var value = new proto.skyfront.RtkCloudOverrides;
      reader.readMessage(value,proto.skyfront.RtkCloudOverrides.deserializeBinaryFromReader);
      msg.setRtkCloudOverrides(value);
      break;
    case 4:
      var value = new proto.skyfront.VideoCaptureCloudOverrides;
      reader.readMessage(value,proto.skyfront.VideoCaptureCloudOverrides.deserializeBinaryFromReader);
      msg.setVideoCaptureCloudOverrides(value);
      break;
    case 5:
      var value = new proto.skyfront.ParaverseScenarioMarkerCloudOverrides;
      reader.readMessage(value,proto.skyfront.ParaverseScenarioMarkerCloudOverrides.deserializeBinaryFromReader);
      msg.setParaverseScenarioMarkerCloudOverrides(value);
      break;
    case 6:
      var value = new proto.skyfront.WeatherInferenceCloudOverrides;
      reader.readMessage(value,proto.skyfront.WeatherInferenceCloudOverrides.deserializeBinaryFromReader);
      msg.setWeatherInferenceCloudOverrides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.DeviceCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.DeviceCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.DeviceCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.DeviceCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSampleCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getLocationStreamCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skyfront.LocationStreamCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getRtkCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.skyfront.RtkCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getVideoCaptureCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.skyfront.VideoCaptureCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getParaverseScenarioMarkerCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.skyfront.ParaverseScenarioMarkerCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getWeatherInferenceCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.skyfront.WeatherInferenceCloudOverrides.serializeBinaryToWriter
    );
  }
};


/**
 * optional SampleCloudOverrides sample_cloud_overrides = 1;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.prototype.getSampleCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SampleCloudOverrides, 1));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
*/
proto.skyfront.DeviceCloudOverrides.prototype.setSampleCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
 */
proto.skyfront.DeviceCloudOverrides.prototype.clearSampleCloudOverrides = function() {
  return this.setSampleCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.DeviceCloudOverrides.prototype.hasSampleCloudOverrides = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LocationStreamCloudOverrides location_stream_cloud_overrides = 2;
 * @return {?proto.skyfront.LocationStreamCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.prototype.getLocationStreamCloudOverrides = function() {
  return /** @type{?proto.skyfront.LocationStreamCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.LocationStreamCloudOverrides, 2));
};


/**
 * @param {?proto.skyfront.LocationStreamCloudOverrides|undefined} value
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
*/
proto.skyfront.DeviceCloudOverrides.prototype.setLocationStreamCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
 */
proto.skyfront.DeviceCloudOverrides.prototype.clearLocationStreamCloudOverrides = function() {
  return this.setLocationStreamCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.DeviceCloudOverrides.prototype.hasLocationStreamCloudOverrides = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RtkCloudOverrides rtk_cloud_overrides = 3;
 * @return {?proto.skyfront.RtkCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.prototype.getRtkCloudOverrides = function() {
  return /** @type{?proto.skyfront.RtkCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.RtkCloudOverrides, 3));
};


/**
 * @param {?proto.skyfront.RtkCloudOverrides|undefined} value
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
*/
proto.skyfront.DeviceCloudOverrides.prototype.setRtkCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
 */
proto.skyfront.DeviceCloudOverrides.prototype.clearRtkCloudOverrides = function() {
  return this.setRtkCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.DeviceCloudOverrides.prototype.hasRtkCloudOverrides = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional VideoCaptureCloudOverrides video_capture_cloud_overrides = 4;
 * @return {?proto.skyfront.VideoCaptureCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.prototype.getVideoCaptureCloudOverrides = function() {
  return /** @type{?proto.skyfront.VideoCaptureCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.VideoCaptureCloudOverrides, 4));
};


/**
 * @param {?proto.skyfront.VideoCaptureCloudOverrides|undefined} value
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
*/
proto.skyfront.DeviceCloudOverrides.prototype.setVideoCaptureCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
 */
proto.skyfront.DeviceCloudOverrides.prototype.clearVideoCaptureCloudOverrides = function() {
  return this.setVideoCaptureCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.DeviceCloudOverrides.prototype.hasVideoCaptureCloudOverrides = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ParaverseScenarioMarkerCloudOverrides paraverse_scenario_marker_cloud_overrides = 5;
 * @return {?proto.skyfront.ParaverseScenarioMarkerCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.prototype.getParaverseScenarioMarkerCloudOverrides = function() {
  return /** @type{?proto.skyfront.ParaverseScenarioMarkerCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.ParaverseScenarioMarkerCloudOverrides, 5));
};


/**
 * @param {?proto.skyfront.ParaverseScenarioMarkerCloudOverrides|undefined} value
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
*/
proto.skyfront.DeviceCloudOverrides.prototype.setParaverseScenarioMarkerCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
 */
proto.skyfront.DeviceCloudOverrides.prototype.clearParaverseScenarioMarkerCloudOverrides = function() {
  return this.setParaverseScenarioMarkerCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.DeviceCloudOverrides.prototype.hasParaverseScenarioMarkerCloudOverrides = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional WeatherInferenceCloudOverrides weather_inference_cloud_overrides = 6;
 * @return {?proto.skyfront.WeatherInferenceCloudOverrides}
 */
proto.skyfront.DeviceCloudOverrides.prototype.getWeatherInferenceCloudOverrides = function() {
  return /** @type{?proto.skyfront.WeatherInferenceCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.WeatherInferenceCloudOverrides, 6));
};


/**
 * @param {?proto.skyfront.WeatherInferenceCloudOverrides|undefined} value
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
*/
proto.skyfront.DeviceCloudOverrides.prototype.setWeatherInferenceCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.DeviceCloudOverrides} returns this
 */
proto.skyfront.DeviceCloudOverrides.prototype.clearWeatherInferenceCloudOverrides = function() {
  return this.setWeatherInferenceCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.DeviceCloudOverrides.prototype.hasWeatherInferenceCloudOverrides = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.skyfront.SkyfrontCloudOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skyfront.SkyfrontCloudOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SkyfrontCloudOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
wacsCloudOverrides: (f = msg.getWacsCloudOverrides()) && proto.skyfront.WacsCloudOverrides.toObject(includeInstance, f),
sampleCloudOverrides: (f = msg.getSampleCloudOverrides()) && proto.skyfront.SampleCloudOverrides.toObject(includeInstance, f),
sampleGoCloudOverrides: (f = msg.getSampleGoCloudOverrides()) && proto.skyfront.SampleCloudOverrides.toObject(includeInstance, f),
siteSecurityCloudOverrides: (f = msg.getSiteSecurityCloudOverrides()) && proto.skyfront.SiteSecurityCloudOverrides.toObject(includeInstance, f),
simOrchestratorCloudOverrides: (f = msg.getSimOrchestratorCloudOverrides()) && proto.skyfront.SimOrchestratorCloudOverrides.toObject(includeInstance, f),
locationStreamCloudOverrides: (f = msg.getLocationStreamCloudOverrides()) && proto.skyfront.LocationStreamCloudOverrides.toObject(includeInstance, f),
rtkCloudOverrides: (f = msg.getRtkCloudOverrides()) && proto.skyfront.RtkCloudOverrides.toObject(includeInstance, f),
videoCaptureCloudOverrides: (f = msg.getVideoCaptureCloudOverrides()) && proto.skyfront.VideoCaptureCloudOverrides.toObject(includeInstance, f),
paraverseScenarioMarkerCloudOverrides: (f = msg.getParaverseScenarioMarkerCloudOverrides()) && proto.skyfront.ParaverseScenarioMarkerCloudOverrides.toObject(includeInstance, f),
weatherInferenceCloudOverrides: (f = msg.getWeatherInferenceCloudOverrides()) && proto.skyfront.WeatherInferenceCloudOverrides.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skyfront.SkyfrontCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skyfront.SkyfrontCloudOverrides;
  return proto.skyfront.SkyfrontCloudOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skyfront.SkyfrontCloudOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skyfront.SkyfrontCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.skyfront.WacsCloudOverrides;
      reader.readMessage(value,proto.skyfront.WacsCloudOverrides.deserializeBinaryFromReader);
      msg.setWacsCloudOverrides(value);
      break;
    case 2:
      var value = new proto.skyfront.SampleCloudOverrides;
      reader.readMessage(value,proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleCloudOverrides(value);
      break;
    case 3:
      var value = new proto.skyfront.SampleCloudOverrides;
      reader.readMessage(value,proto.skyfront.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleGoCloudOverrides(value);
      break;
    case 4:
      var value = new proto.skyfront.SiteSecurityCloudOverrides;
      reader.readMessage(value,proto.skyfront.SiteSecurityCloudOverrides.deserializeBinaryFromReader);
      msg.setSiteSecurityCloudOverrides(value);
      break;
    case 5:
      var value = new proto.skyfront.SimOrchestratorCloudOverrides;
      reader.readMessage(value,proto.skyfront.SimOrchestratorCloudOverrides.deserializeBinaryFromReader);
      msg.setSimOrchestratorCloudOverrides(value);
      break;
    case 6:
      var value = new proto.skyfront.LocationStreamCloudOverrides;
      reader.readMessage(value,proto.skyfront.LocationStreamCloudOverrides.deserializeBinaryFromReader);
      msg.setLocationStreamCloudOverrides(value);
      break;
    case 7:
      var value = new proto.skyfront.RtkCloudOverrides;
      reader.readMessage(value,proto.skyfront.RtkCloudOverrides.deserializeBinaryFromReader);
      msg.setRtkCloudOverrides(value);
      break;
    case 8:
      var value = new proto.skyfront.VideoCaptureCloudOverrides;
      reader.readMessage(value,proto.skyfront.VideoCaptureCloudOverrides.deserializeBinaryFromReader);
      msg.setVideoCaptureCloudOverrides(value);
      break;
    case 9:
      var value = new proto.skyfront.ParaverseScenarioMarkerCloudOverrides;
      reader.readMessage(value,proto.skyfront.ParaverseScenarioMarkerCloudOverrides.deserializeBinaryFromReader);
      msg.setParaverseScenarioMarkerCloudOverrides(value);
      break;
    case 10:
      var value = new proto.skyfront.WeatherInferenceCloudOverrides;
      reader.readMessage(value,proto.skyfront.WeatherInferenceCloudOverrides.deserializeBinaryFromReader);
      msg.setWeatherInferenceCloudOverrides(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skyfront.SkyfrontCloudOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skyfront.SkyfrontCloudOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skyfront.SkyfrontCloudOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWacsCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.skyfront.WacsCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSampleCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSampleGoCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.skyfront.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSiteSecurityCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.skyfront.SiteSecurityCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSimOrchestratorCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.skyfront.SimOrchestratorCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getLocationStreamCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.skyfront.LocationStreamCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getRtkCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.skyfront.RtkCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getVideoCaptureCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.skyfront.VideoCaptureCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getParaverseScenarioMarkerCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.skyfront.ParaverseScenarioMarkerCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getWeatherInferenceCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.skyfront.WeatherInferenceCloudOverrides.serializeBinaryToWriter
    );
  }
};


/**
 * optional WacsCloudOverrides wacs_cloud_overrides = 1;
 * @return {?proto.skyfront.WacsCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getWacsCloudOverrides = function() {
  return /** @type{?proto.skyfront.WacsCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.WacsCloudOverrides, 1));
};


/**
 * @param {?proto.skyfront.WacsCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setWacsCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearWacsCloudOverrides = function() {
  return this.setWacsCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasWacsCloudOverrides = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SampleCloudOverrides sample_cloud_overrides = 2;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getSampleCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SampleCloudOverrides, 2));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setSampleCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearSampleCloudOverrides = function() {
  return this.setSampleCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasSampleCloudOverrides = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SampleCloudOverrides sample_go_cloud_overrides = 3;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getSampleGoCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SampleCloudOverrides, 3));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setSampleGoCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearSampleGoCloudOverrides = function() {
  return this.setSampleGoCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasSampleGoCloudOverrides = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SiteSecurityCloudOverrides site_security_cloud_overrides = 4;
 * @return {?proto.skyfront.SiteSecurityCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getSiteSecurityCloudOverrides = function() {
  return /** @type{?proto.skyfront.SiteSecurityCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SiteSecurityCloudOverrides, 4));
};


/**
 * @param {?proto.skyfront.SiteSecurityCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setSiteSecurityCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearSiteSecurityCloudOverrides = function() {
  return this.setSiteSecurityCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasSiteSecurityCloudOverrides = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SimOrchestratorCloudOverrides sim_orchestrator_cloud_overrides = 5;
 * @return {?proto.skyfront.SimOrchestratorCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getSimOrchestratorCloudOverrides = function() {
  return /** @type{?proto.skyfront.SimOrchestratorCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.SimOrchestratorCloudOverrides, 5));
};


/**
 * @param {?proto.skyfront.SimOrchestratorCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setSimOrchestratorCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearSimOrchestratorCloudOverrides = function() {
  return this.setSimOrchestratorCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasSimOrchestratorCloudOverrides = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional LocationStreamCloudOverrides location_stream_cloud_overrides = 6;
 * @return {?proto.skyfront.LocationStreamCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getLocationStreamCloudOverrides = function() {
  return /** @type{?proto.skyfront.LocationStreamCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.LocationStreamCloudOverrides, 6));
};


/**
 * @param {?proto.skyfront.LocationStreamCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setLocationStreamCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearLocationStreamCloudOverrides = function() {
  return this.setLocationStreamCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasLocationStreamCloudOverrides = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RtkCloudOverrides rtk_cloud_overrides = 7;
 * @return {?proto.skyfront.RtkCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getRtkCloudOverrides = function() {
  return /** @type{?proto.skyfront.RtkCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.RtkCloudOverrides, 7));
};


/**
 * @param {?proto.skyfront.RtkCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setRtkCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearRtkCloudOverrides = function() {
  return this.setRtkCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasRtkCloudOverrides = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional VideoCaptureCloudOverrides video_capture_cloud_overrides = 8;
 * @return {?proto.skyfront.VideoCaptureCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getVideoCaptureCloudOverrides = function() {
  return /** @type{?proto.skyfront.VideoCaptureCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.VideoCaptureCloudOverrides, 8));
};


/**
 * @param {?proto.skyfront.VideoCaptureCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setVideoCaptureCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearVideoCaptureCloudOverrides = function() {
  return this.setVideoCaptureCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasVideoCaptureCloudOverrides = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ParaverseScenarioMarkerCloudOverrides paraverse_scenario_marker_cloud_overrides = 9;
 * @return {?proto.skyfront.ParaverseScenarioMarkerCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getParaverseScenarioMarkerCloudOverrides = function() {
  return /** @type{?proto.skyfront.ParaverseScenarioMarkerCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.ParaverseScenarioMarkerCloudOverrides, 9));
};


/**
 * @param {?proto.skyfront.ParaverseScenarioMarkerCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setParaverseScenarioMarkerCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearParaverseScenarioMarkerCloudOverrides = function() {
  return this.setParaverseScenarioMarkerCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasParaverseScenarioMarkerCloudOverrides = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional WeatherInferenceCloudOverrides weather_inference_cloud_overrides = 10;
 * @return {?proto.skyfront.WeatherInferenceCloudOverrides}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.getWeatherInferenceCloudOverrides = function() {
  return /** @type{?proto.skyfront.WeatherInferenceCloudOverrides} */ (
    jspb.Message.getWrapperField(this, proto.skyfront.WeatherInferenceCloudOverrides, 10));
};


/**
 * @param {?proto.skyfront.WeatherInferenceCloudOverrides|undefined} value
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
*/
proto.skyfront.SkyfrontCloudOverrides.prototype.setWeatherInferenceCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skyfront.SkyfrontCloudOverrides} returns this
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.clearWeatherInferenceCloudOverrides = function() {
  return this.setWeatherInferenceCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skyfront.SkyfrontCloudOverrides.prototype.hasWeatherInferenceCloudOverrides = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * @enum {number}
 */
proto.skyfront.WacsReleaseVersion = {
  WACS_RELEASE_VERSION_CAYLEY: 0,
  WACS_RELEASE_VERSION_DRAPER: 1
};

goog.object.extend(exports, proto.skyfront);
